/**
 * @fileoverview gRPC-Web generated client stub for wisetime.site.timesheetfield.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.14.0
// source: wisetime/site/timesheetfield/v1/timesheet_field.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as google_protobuf_empty_pb from 'google-protobuf/google/protobuf/empty_pb';
import * as wisetime_site_timesheetfield_v1_timesheet_field_pb from '../../../../wisetime/site/timesheetfield/v1/timesheet_field_pb';


export class TimesheetFieldServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorListTimesheetFields = new grpcWeb.MethodDescriptor(
    '/wisetime.site.timesheetfield.v1.TimesheetFieldService/ListTimesheetFields',
    grpcWeb.MethodType.UNARY,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.ListTimesheetFieldsRequest,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.ListTimesheetFieldsResponse,
    (request: wisetime_site_timesheetfield_v1_timesheet_field_pb.ListTimesheetFieldsRequest) => {
      return request.serializeBinary();
    },
    wisetime_site_timesheetfield_v1_timesheet_field_pb.ListTimesheetFieldsResponse.deserializeBinary
  );

  listTimesheetFields(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.ListTimesheetFieldsRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_site_timesheetfield_v1_timesheet_field_pb.ListTimesheetFieldsResponse>;

  listTimesheetFields(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.ListTimesheetFieldsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_site_timesheetfield_v1_timesheet_field_pb.ListTimesheetFieldsResponse) => void): grpcWeb.ClientReadableStream<wisetime_site_timesheetfield_v1_timesheet_field_pb.ListTimesheetFieldsResponse>;

  listTimesheetFields(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.ListTimesheetFieldsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_site_timesheetfield_v1_timesheet_field_pb.ListTimesheetFieldsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.site.timesheetfield.v1.TimesheetFieldService/ListTimesheetFields',
        request,
        metadata || {},
        this.methodDescriptorListTimesheetFields,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.site.timesheetfield.v1.TimesheetFieldService/ListTimesheetFields',
    request,
    metadata || {},
    this.methodDescriptorListTimesheetFields);
  }

  methodDescriptorCreateTimesheetField = new grpcWeb.MethodDescriptor(
    '/wisetime.site.timesheetfield.v1.TimesheetFieldService/CreateTimesheetField',
    grpcWeb.MethodType.UNARY,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.CreateTimesheetFieldRequest,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.TimesheetField,
    (request: wisetime_site_timesheetfield_v1_timesheet_field_pb.CreateTimesheetFieldRequest) => {
      return request.serializeBinary();
    },
    wisetime_site_timesheetfield_v1_timesheet_field_pb.TimesheetField.deserializeBinary
  );

  createTimesheetField(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.CreateTimesheetFieldRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_site_timesheetfield_v1_timesheet_field_pb.TimesheetField>;

  createTimesheetField(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.CreateTimesheetFieldRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_site_timesheetfield_v1_timesheet_field_pb.TimesheetField) => void): grpcWeb.ClientReadableStream<wisetime_site_timesheetfield_v1_timesheet_field_pb.TimesheetField>;

  createTimesheetField(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.CreateTimesheetFieldRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_site_timesheetfield_v1_timesheet_field_pb.TimesheetField) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.site.timesheetfield.v1.TimesheetFieldService/CreateTimesheetField',
        request,
        metadata || {},
        this.methodDescriptorCreateTimesheetField,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.site.timesheetfield.v1.TimesheetFieldService/CreateTimesheetField',
    request,
    metadata || {},
    this.methodDescriptorCreateTimesheetField);
  }

  methodDescriptorDeleteTimesheetField = new grpcWeb.MethodDescriptor(
    '/wisetime.site.timesheetfield.v1.TimesheetFieldService/DeleteTimesheetField',
    grpcWeb.MethodType.UNARY,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.DeleteTimesheetFieldRequest,
    google_protobuf_empty_pb.Empty,
    (request: wisetime_site_timesheetfield_v1_timesheet_field_pb.DeleteTimesheetFieldRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  deleteTimesheetField(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.DeleteTimesheetFieldRequest,
    metadata: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  deleteTimesheetField(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.DeleteTimesheetFieldRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  deleteTimesheetField(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.DeleteTimesheetFieldRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.site.timesheetfield.v1.TimesheetFieldService/DeleteTimesheetField',
        request,
        metadata || {},
        this.methodDescriptorDeleteTimesheetField,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.site.timesheetfield.v1.TimesheetFieldService/DeleteTimesheetField',
    request,
    metadata || {},
    this.methodDescriptorDeleteTimesheetField);
  }

  methodDescriptorUpdateTimesheetField = new grpcWeb.MethodDescriptor(
    '/wisetime.site.timesheetfield.v1.TimesheetFieldService/UpdateTimesheetField',
    grpcWeb.MethodType.UNARY,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.UpdateTimesheetFieldRequest,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.TimesheetField,
    (request: wisetime_site_timesheetfield_v1_timesheet_field_pb.UpdateTimesheetFieldRequest) => {
      return request.serializeBinary();
    },
    wisetime_site_timesheetfield_v1_timesheet_field_pb.TimesheetField.deserializeBinary
  );

  updateTimesheetField(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.UpdateTimesheetFieldRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_site_timesheetfield_v1_timesheet_field_pb.TimesheetField>;

  updateTimesheetField(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.UpdateTimesheetFieldRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_site_timesheetfield_v1_timesheet_field_pb.TimesheetField) => void): grpcWeb.ClientReadableStream<wisetime_site_timesheetfield_v1_timesheet_field_pb.TimesheetField>;

  updateTimesheetField(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.UpdateTimesheetFieldRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_site_timesheetfield_v1_timesheet_field_pb.TimesheetField) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.site.timesheetfield.v1.TimesheetFieldService/UpdateTimesheetField',
        request,
        metadata || {},
        this.methodDescriptorUpdateTimesheetField,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.site.timesheetfield.v1.TimesheetFieldService/UpdateTimesheetField',
    request,
    metadata || {},
    this.methodDescriptorUpdateTimesheetField);
  }

  methodDescriptorCreateTimesheetFieldOption = new grpcWeb.MethodDescriptor(
    '/wisetime.site.timesheetfield.v1.TimesheetFieldService/CreateTimesheetFieldOption',
    grpcWeb.MethodType.UNARY,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.CreateTimesheetFieldOptionRequest,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.TimesheetFieldOption,
    (request: wisetime_site_timesheetfield_v1_timesheet_field_pb.CreateTimesheetFieldOptionRequest) => {
      return request.serializeBinary();
    },
    wisetime_site_timesheetfield_v1_timesheet_field_pb.TimesheetFieldOption.deserializeBinary
  );

  createTimesheetFieldOption(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.CreateTimesheetFieldOptionRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_site_timesheetfield_v1_timesheet_field_pb.TimesheetFieldOption>;

  createTimesheetFieldOption(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.CreateTimesheetFieldOptionRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_site_timesheetfield_v1_timesheet_field_pb.TimesheetFieldOption) => void): grpcWeb.ClientReadableStream<wisetime_site_timesheetfield_v1_timesheet_field_pb.TimesheetFieldOption>;

  createTimesheetFieldOption(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.CreateTimesheetFieldOptionRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_site_timesheetfield_v1_timesheet_field_pb.TimesheetFieldOption) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.site.timesheetfield.v1.TimesheetFieldService/CreateTimesheetFieldOption',
        request,
        metadata || {},
        this.methodDescriptorCreateTimesheetFieldOption,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.site.timesheetfield.v1.TimesheetFieldService/CreateTimesheetFieldOption',
    request,
    metadata || {},
    this.methodDescriptorCreateTimesheetFieldOption);
  }

  methodDescriptorDeleteTimesheetFieldOption = new grpcWeb.MethodDescriptor(
    '/wisetime.site.timesheetfield.v1.TimesheetFieldService/DeleteTimesheetFieldOption',
    grpcWeb.MethodType.UNARY,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.DeleteTimesheetFieldOptionRequest,
    google_protobuf_empty_pb.Empty,
    (request: wisetime_site_timesheetfield_v1_timesheet_field_pb.DeleteTimesheetFieldOptionRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  deleteTimesheetFieldOption(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.DeleteTimesheetFieldOptionRequest,
    metadata: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  deleteTimesheetFieldOption(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.DeleteTimesheetFieldOptionRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  deleteTimesheetFieldOption(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.DeleteTimesheetFieldOptionRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.site.timesheetfield.v1.TimesheetFieldService/DeleteTimesheetFieldOption',
        request,
        metadata || {},
        this.methodDescriptorDeleteTimesheetFieldOption,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.site.timesheetfield.v1.TimesheetFieldService/DeleteTimesheetFieldOption',
    request,
    metadata || {},
    this.methodDescriptorDeleteTimesheetFieldOption);
  }

  methodDescriptorUpdateTimesheetFieldOption = new grpcWeb.MethodDescriptor(
    '/wisetime.site.timesheetfield.v1.TimesheetFieldService/UpdateTimesheetFieldOption',
    grpcWeb.MethodType.UNARY,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.UpdateTimesheetFieldOptionRequest,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.TimesheetFieldOption,
    (request: wisetime_site_timesheetfield_v1_timesheet_field_pb.UpdateTimesheetFieldOptionRequest) => {
      return request.serializeBinary();
    },
    wisetime_site_timesheetfield_v1_timesheet_field_pb.TimesheetFieldOption.deserializeBinary
  );

  updateTimesheetFieldOption(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.UpdateTimesheetFieldOptionRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_site_timesheetfield_v1_timesheet_field_pb.TimesheetFieldOption>;

  updateTimesheetFieldOption(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.UpdateTimesheetFieldOptionRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_site_timesheetfield_v1_timesheet_field_pb.TimesheetFieldOption) => void): grpcWeb.ClientReadableStream<wisetime_site_timesheetfield_v1_timesheet_field_pb.TimesheetFieldOption>;

  updateTimesheetFieldOption(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.UpdateTimesheetFieldOptionRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_site_timesheetfield_v1_timesheet_field_pb.TimesheetFieldOption) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.site.timesheetfield.v1.TimesheetFieldService/UpdateTimesheetFieldOption',
        request,
        metadata || {},
        this.methodDescriptorUpdateTimesheetFieldOption,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.site.timesheetfield.v1.TimesheetFieldService/UpdateTimesheetFieldOption',
    request,
    metadata || {},
    this.methodDescriptorUpdateTimesheetFieldOption);
  }

  methodDescriptorDisableTimesheetFieldOptions = new grpcWeb.MethodDescriptor(
    '/wisetime.site.timesheetfield.v1.TimesheetFieldService/DisableTimesheetFieldOptions',
    grpcWeb.MethodType.UNARY,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.DisableTimesheetFieldOptionsRequest,
    google_protobuf_empty_pb.Empty,
    (request: wisetime_site_timesheetfield_v1_timesheet_field_pb.DisableTimesheetFieldOptionsRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  disableTimesheetFieldOptions(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.DisableTimesheetFieldOptionsRequest,
    metadata: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  disableTimesheetFieldOptions(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.DisableTimesheetFieldOptionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  disableTimesheetFieldOptions(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.DisableTimesheetFieldOptionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.site.timesheetfield.v1.TimesheetFieldService/DisableTimesheetFieldOptions',
        request,
        metadata || {},
        this.methodDescriptorDisableTimesheetFieldOptions,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.site.timesheetfield.v1.TimesheetFieldService/DisableTimesheetFieldOptions',
    request,
    metadata || {},
    this.methodDescriptorDisableTimesheetFieldOptions);
  }

  methodDescriptorEnableTimesheetFieldOptions = new grpcWeb.MethodDescriptor(
    '/wisetime.site.timesheetfield.v1.TimesheetFieldService/EnableTimesheetFieldOptions',
    grpcWeb.MethodType.UNARY,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.EnableTimesheetFieldOptionsRequest,
    google_protobuf_empty_pb.Empty,
    (request: wisetime_site_timesheetfield_v1_timesheet_field_pb.EnableTimesheetFieldOptionsRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  enableTimesheetFieldOptions(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.EnableTimesheetFieldOptionsRequest,
    metadata: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  enableTimesheetFieldOptions(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.EnableTimesheetFieldOptionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  enableTimesheetFieldOptions(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.EnableTimesheetFieldOptionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.site.timesheetfield.v1.TimesheetFieldService/EnableTimesheetFieldOptions',
        request,
        metadata || {},
        this.methodDescriptorEnableTimesheetFieldOptions,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.site.timesheetfield.v1.TimesheetFieldService/EnableTimesheetFieldOptions',
    request,
    metadata || {},
    this.methodDescriptorEnableTimesheetFieldOptions);
  }

  methodDescriptorGenerateTimesheetFieldConfigs = new grpcWeb.MethodDescriptor(
    '/wisetime.site.timesheetfield.v1.TimesheetFieldService/GenerateTimesheetFieldConfigs',
    grpcWeb.MethodType.UNARY,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.GenerateTimesheetFieldConfigsRequest,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.GenerateTimesheetFieldConfigsResponse,
    (request: wisetime_site_timesheetfield_v1_timesheet_field_pb.GenerateTimesheetFieldConfigsRequest) => {
      return request.serializeBinary();
    },
    wisetime_site_timesheetfield_v1_timesheet_field_pb.GenerateTimesheetFieldConfigsResponse.deserializeBinary
  );

  generateTimesheetFieldConfigs(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.GenerateTimesheetFieldConfigsRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_site_timesheetfield_v1_timesheet_field_pb.GenerateTimesheetFieldConfigsResponse>;

  generateTimesheetFieldConfigs(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.GenerateTimesheetFieldConfigsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_site_timesheetfield_v1_timesheet_field_pb.GenerateTimesheetFieldConfigsResponse) => void): grpcWeb.ClientReadableStream<wisetime_site_timesheetfield_v1_timesheet_field_pb.GenerateTimesheetFieldConfigsResponse>;

  generateTimesheetFieldConfigs(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.GenerateTimesheetFieldConfigsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_site_timesheetfield_v1_timesheet_field_pb.GenerateTimesheetFieldConfigsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.site.timesheetfield.v1.TimesheetFieldService/GenerateTimesheetFieldConfigs',
        request,
        metadata || {},
        this.methodDescriptorGenerateTimesheetFieldConfigs,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.site.timesheetfield.v1.TimesheetFieldService/GenerateTimesheetFieldConfigs',
    request,
    metadata || {},
    this.methodDescriptorGenerateTimesheetFieldConfigs);
  }

  methodDescriptorBatchGetTimesheetFieldConfigs = new grpcWeb.MethodDescriptor(
    '/wisetime.site.timesheetfield.v1.TimesheetFieldService/BatchGetTimesheetFieldConfigs',
    grpcWeb.MethodType.UNARY,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.BatchGetTimesheetFieldConfigsRequest,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.BatchGetTimesheetFieldConfigsResponse,
    (request: wisetime_site_timesheetfield_v1_timesheet_field_pb.BatchGetTimesheetFieldConfigsRequest) => {
      return request.serializeBinary();
    },
    wisetime_site_timesheetfield_v1_timesheet_field_pb.BatchGetTimesheetFieldConfigsResponse.deserializeBinary
  );

  batchGetTimesheetFieldConfigs(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.BatchGetTimesheetFieldConfigsRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_site_timesheetfield_v1_timesheet_field_pb.BatchGetTimesheetFieldConfigsResponse>;

  batchGetTimesheetFieldConfigs(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.BatchGetTimesheetFieldConfigsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_site_timesheetfield_v1_timesheet_field_pb.BatchGetTimesheetFieldConfigsResponse) => void): grpcWeb.ClientReadableStream<wisetime_site_timesheetfield_v1_timesheet_field_pb.BatchGetTimesheetFieldConfigsResponse>;

  batchGetTimesheetFieldConfigs(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.BatchGetTimesheetFieldConfigsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_site_timesheetfield_v1_timesheet_field_pb.BatchGetTimesheetFieldConfigsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.site.timesheetfield.v1.TimesheetFieldService/BatchGetTimesheetFieldConfigs',
        request,
        metadata || {},
        this.methodDescriptorBatchGetTimesheetFieldConfigs,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.site.timesheetfield.v1.TimesheetFieldService/BatchGetTimesheetFieldConfigs',
    request,
    metadata || {},
    this.methodDescriptorBatchGetTimesheetFieldConfigs);
  }

  methodDescriptorBatchGetTimesheetFieldOptions = new grpcWeb.MethodDescriptor(
    '/wisetime.site.timesheetfield.v1.TimesheetFieldService/BatchGetTimesheetFieldOptions',
    grpcWeb.MethodType.UNARY,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.BatchGetTimesheetFieldOptionsRequest,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.BatchGetTimesheetFieldOptionsResponse,
    (request: wisetime_site_timesheetfield_v1_timesheet_field_pb.BatchGetTimesheetFieldOptionsRequest) => {
      return request.serializeBinary();
    },
    wisetime_site_timesheetfield_v1_timesheet_field_pb.BatchGetTimesheetFieldOptionsResponse.deserializeBinary
  );

  batchGetTimesheetFieldOptions(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.BatchGetTimesheetFieldOptionsRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_site_timesheetfield_v1_timesheet_field_pb.BatchGetTimesheetFieldOptionsResponse>;

  batchGetTimesheetFieldOptions(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.BatchGetTimesheetFieldOptionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_site_timesheetfield_v1_timesheet_field_pb.BatchGetTimesheetFieldOptionsResponse) => void): grpcWeb.ClientReadableStream<wisetime_site_timesheetfield_v1_timesheet_field_pb.BatchGetTimesheetFieldOptionsResponse>;

  batchGetTimesheetFieldOptions(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.BatchGetTimesheetFieldOptionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_site_timesheetfield_v1_timesheet_field_pb.BatchGetTimesheetFieldOptionsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.site.timesheetfield.v1.TimesheetFieldService/BatchGetTimesheetFieldOptions',
        request,
        metadata || {},
        this.methodDescriptorBatchGetTimesheetFieldOptions,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.site.timesheetfield.v1.TimesheetFieldService/BatchGetTimesheetFieldOptions',
    request,
    metadata || {},
    this.methodDescriptorBatchGetTimesheetFieldOptions);
  }

  methodDescriptorListFavouriteTimesheetFieldOptions = new grpcWeb.MethodDescriptor(
    '/wisetime.site.timesheetfield.v1.TimesheetFieldService/ListFavouriteTimesheetFieldOptions',
    grpcWeb.MethodType.UNARY,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsRequest,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsResponse,
    (request: wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsRequest) => {
      return request.serializeBinary();
    },
    wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsResponse.deserializeBinary
  );

  listFavouriteTimesheetFieldOptions(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsResponse>;

  listFavouriteTimesheetFieldOptions(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsResponse) => void): grpcWeb.ClientReadableStream<wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsResponse>;

  listFavouriteTimesheetFieldOptions(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.site.timesheetfield.v1.TimesheetFieldService/ListFavouriteTimesheetFieldOptions',
        request,
        metadata || {},
        this.methodDescriptorListFavouriteTimesheetFieldOptions,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.site.timesheetfield.v1.TimesheetFieldService/ListFavouriteTimesheetFieldOptions',
    request,
    metadata || {},
    this.methodDescriptorListFavouriteTimesheetFieldOptions);
  }

  methodDescriptorAddFavouriteTimesheetFieldOption = new grpcWeb.MethodDescriptor(
    '/wisetime.site.timesheetfield.v1.TimesheetFieldService/AddFavouriteTimesheetFieldOption',
    grpcWeb.MethodType.UNARY,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.AddFavouriteTimesheetFieldOptionRequest,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsResponse,
    (request: wisetime_site_timesheetfield_v1_timesheet_field_pb.AddFavouriteTimesheetFieldOptionRequest) => {
      return request.serializeBinary();
    },
    wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsResponse.deserializeBinary
  );

  addFavouriteTimesheetFieldOption(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.AddFavouriteTimesheetFieldOptionRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsResponse>;

  addFavouriteTimesheetFieldOption(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.AddFavouriteTimesheetFieldOptionRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsResponse) => void): grpcWeb.ClientReadableStream<wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsResponse>;

  addFavouriteTimesheetFieldOption(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.AddFavouriteTimesheetFieldOptionRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.site.timesheetfield.v1.TimesheetFieldService/AddFavouriteTimesheetFieldOption',
        request,
        metadata || {},
        this.methodDescriptorAddFavouriteTimesheetFieldOption,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.site.timesheetfield.v1.TimesheetFieldService/AddFavouriteTimesheetFieldOption',
    request,
    metadata || {},
    this.methodDescriptorAddFavouriteTimesheetFieldOption);
  }

  methodDescriptorRemoveFavouriteTimesheetFieldOption = new grpcWeb.MethodDescriptor(
    '/wisetime.site.timesheetfield.v1.TimesheetFieldService/RemoveFavouriteTimesheetFieldOption',
    grpcWeb.MethodType.UNARY,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.RemoveFavouriteTimesheetFieldOptionRequest,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsResponse,
    (request: wisetime_site_timesheetfield_v1_timesheet_field_pb.RemoveFavouriteTimesheetFieldOptionRequest) => {
      return request.serializeBinary();
    },
    wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsResponse.deserializeBinary
  );

  removeFavouriteTimesheetFieldOption(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.RemoveFavouriteTimesheetFieldOptionRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsResponse>;

  removeFavouriteTimesheetFieldOption(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.RemoveFavouriteTimesheetFieldOptionRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsResponse) => void): grpcWeb.ClientReadableStream<wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsResponse>;

  removeFavouriteTimesheetFieldOption(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.RemoveFavouriteTimesheetFieldOptionRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.site.timesheetfield.v1.TimesheetFieldService/RemoveFavouriteTimesheetFieldOption',
        request,
        metadata || {},
        this.methodDescriptorRemoveFavouriteTimesheetFieldOption,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.site.timesheetfield.v1.TimesheetFieldService/RemoveFavouriteTimesheetFieldOption',
    request,
    metadata || {},
    this.methodDescriptorRemoveFavouriteTimesheetFieldOption);
  }

  methodDescriptorReorderFavouriteTimesheetFieldOption = new grpcWeb.MethodDescriptor(
    '/wisetime.site.timesheetfield.v1.TimesheetFieldService/ReorderFavouriteTimesheetFieldOption',
    grpcWeb.MethodType.UNARY,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.ReorderFavouriteTimesheetFieldOptionRequest,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsResponse,
    (request: wisetime_site_timesheetfield_v1_timesheet_field_pb.ReorderFavouriteTimesheetFieldOptionRequest) => {
      return request.serializeBinary();
    },
    wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsResponse.deserializeBinary
  );

  reorderFavouriteTimesheetFieldOption(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.ReorderFavouriteTimesheetFieldOptionRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsResponse>;

  reorderFavouriteTimesheetFieldOption(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.ReorderFavouriteTimesheetFieldOptionRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsResponse) => void): grpcWeb.ClientReadableStream<wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsResponse>;

  reorderFavouriteTimesheetFieldOption(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.ReorderFavouriteTimesheetFieldOptionRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_site_timesheetfield_v1_timesheet_field_pb.ListFavouriteTimesheetFieldOptionsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.site.timesheetfield.v1.TimesheetFieldService/ReorderFavouriteTimesheetFieldOption',
        request,
        metadata || {},
        this.methodDescriptorReorderFavouriteTimesheetFieldOption,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.site.timesheetfield.v1.TimesheetFieldService/ReorderFavouriteTimesheetFieldOption',
    request,
    metadata || {},
    this.methodDescriptorReorderFavouriteTimesheetFieldOption);
  }

  methodDescriptorListRecentTimesheetFieldOptions = new grpcWeb.MethodDescriptor(
    '/wisetime.site.timesheetfield.v1.TimesheetFieldService/ListRecentTimesheetFieldOptions',
    grpcWeb.MethodType.UNARY,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.ListRecentTimesheetFieldOptionsRequest,
    wisetime_site_timesheetfield_v1_timesheet_field_pb.ListRecentTimesheetFieldOptionsResponse,
    (request: wisetime_site_timesheetfield_v1_timesheet_field_pb.ListRecentTimesheetFieldOptionsRequest) => {
      return request.serializeBinary();
    },
    wisetime_site_timesheetfield_v1_timesheet_field_pb.ListRecentTimesheetFieldOptionsResponse.deserializeBinary
  );

  listRecentTimesheetFieldOptions(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.ListRecentTimesheetFieldOptionsRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_site_timesheetfield_v1_timesheet_field_pb.ListRecentTimesheetFieldOptionsResponse>;

  listRecentTimesheetFieldOptions(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.ListRecentTimesheetFieldOptionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_site_timesheetfield_v1_timesheet_field_pb.ListRecentTimesheetFieldOptionsResponse) => void): grpcWeb.ClientReadableStream<wisetime_site_timesheetfield_v1_timesheet_field_pb.ListRecentTimesheetFieldOptionsResponse>;

  listRecentTimesheetFieldOptions(
    request: wisetime_site_timesheetfield_v1_timesheet_field_pb.ListRecentTimesheetFieldOptionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_site_timesheetfield_v1_timesheet_field_pb.ListRecentTimesheetFieldOptionsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.site.timesheetfield.v1.TimesheetFieldService/ListRecentTimesheetFieldOptions',
        request,
        metadata || {},
        this.methodDescriptorListRecentTimesheetFieldOptions,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.site.timesheetfield.v1.TimesheetFieldService/ListRecentTimesheetFieldOptions',
    request,
    metadata || {},
    this.methodDescriptorListRecentTimesheetFieldOptions);
  }

}

